import { Component, OnInit, Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import { Router, NavigationExtras } from '@angular/router';
import { LocalDataSource } from 'ng2-smart-table';
import { ModalCheckBoxEntidadActComponent } from '../modal-check-box-entidad-act/modal-check-box-entidad-act.component';


@Component({
  selector: 'ngx-modal-add-entidad-actividades',
  templateUrl: './modal-add-entidad-actividades.component.html',
  styleUrls: ['./modal-add-entidad-actividades.component.scss'],
  providers: [PeticionesHttpBackEndService, UtilidadesService]
})



export class ModalAddEntidadActividadesComponent implements OnInit {
  private valorSelect: number;
  resultEntidades:any;
  constructor(private router:Router, public utilidades: UtilidadesService, public dialogRef: MatDialogRef<ModalAddEntidadActividadesComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any, public _PeticionesHttpBackEndService: PeticionesHttpBackEndService, private authService: NbAuthService,public dialog: MatDialog) { 

  }
  tokenRequest: any;
  dataa = [
    {
      Nombre: "PEPE",
      Apellidos: "Leanne Graham",
      EmpresaInstitucion: "Bret",
    }
  ];
  settings = {
    mode: 'inline',
    sort: true,
    noDataMessage: "No se han encontrado resultados.",
    actions: {
      columnTitle: "Acciones",
      add: false,
      edit: false,
      delete:false
    },
    pager: {
			display: true,
			perPage: 3//2
		},
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    columns: {
      Nombre: {
        title: 'Nombre',
        type: 'string',
        filter: true
      },
      Apellidos: {
        title: 'Apellidos',
        type: 'string',
        filter: true
      },
      NombreEmpresaInstitucion: {
        title: 'Nombre de empresa o institución',
        type: 'string',
        filter: true
      },
      Email: {
        title: 'Email',
        type: 'string',
        filter: true
      }
    },
  };
 
  source: LocalDataSource = new LocalDataSource();

  ngOnInit() {
    this.authService.getToken()
    .subscribe((token: NbAuthJWTToken) => {
      if (token.isValid()) {
        this.tokenRequest = token;
        this._PeticionesHttpBackEndService.getAllReg("v1/entidades").subscribe(
          result => {
            this.resultEntidades = result;
            this.source.load(this.resultEntidades.Entidades);
          },
          error => {
            this.utilidades.notificationWarning("Error",""+"Ocurrio un problema al cargar la tabla de entidades"+"","top-left");
          });
      }
    }); 
  }
  onRowAddEntSelect(event)
  {
    let dialogRef = this.dialog.open(ModalCheckBoxEntidadActComponent, {
      panelClass: 'custom-dialog',
      data: {
        entidad: event.data,
        actividadId: this.data.ActividadId
      }
    });
  
    dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }

  close(){
    this.dialogRef.close();
  }

}
